<template>
    <div v-loading="isLoading">
        <div class="row">
            <div class="col-sm-2">
                <div class="form-group">
                    <label>State</label>
                    <select class="form-control" v-model="stateFilter" @change="refreshList">
                        <option value="">Please select</option>
                        <option v-for="state in states" :value="state" :key="`feed-state-${state}`">
                            {{ state }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label>Agency</label>
                    <select class="form-control" v-model="agencyFilter" @change="refreshList">
                        <option value="">Please select</option>
                        <option v-for="agency in agencies" :value="agency.id" :key="`feed-agency-${agency.id}`">
                            {{ agency.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-sm-4">
                <label>&nbsp;</label>
                <div class="clearfix"></div>
                <btn :cssClass="`btn btn-info`" :icon="`fa fa-filter`" :click="refreshList">Apply filters</btn>
                <btn :cssClass="`btn btn-info`" :icon="`fa fa-refresh`" :click="refreshList">Refresh</btn>
            </div>
            <div class="col-sm-4">
                <label>&nbsp;</label>
                <div class="clearfix"></div>
                <a :href="url(`admin/settings/feeds/new`)" class="btn btn-primary is-aligned-right">
                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span> New Feed
                </a>
                <btn :cssClass="`btn btn-primary is-aligned-right`" style="margin-right: 5px;" :icon="`fa fa-list-alt`" :click="() => this.openParsersList = true">
                    Parsers
                </btn>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                        <th>Employer</th>
                        <th>State</th>
                        <th>Last Run</th>
                        <th>Parser</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody v-if="feeds.length > 0">
                    <tr v-for="feed in feeds">
                        <td>
                            <template v-if="feed.employer_id">
                                <a :href="url(`admin/employer/${feed.employer_id}/budgets`)">
                                    {{ feed.employer_name }}
                                </a>
                                <employer-icons :employer="feed.employer"></employer-icons>
                            </template>
                            <template v-if="feed.alias">
                                <b>{{ feed.alias }}</b>
                            </template>
                        </td>
                        <td>
                            <span v-if="feed.state === 'Active'">Active</span>
                            <span v-else-if="feed.state === 'Paused'"
                                  style="color: darkgoldenrod; font-weight: bold">Paused</span>
                            <span v-else style="color: red; font-weight: bold">Deleted</span>

                            <i v-if="feed.note" class="fa fa-warning" :title="feed.note"></i>
                        </td>
                        <td v-html="feed.last_run"></td>
                        <td>{{ feed.parser }}</td>
                        <td>
                            <a v-if="feed.state === 'Active'" href="#" @click.prevent="() => inactivateFeed(feed.id)">Pause</a>
                            <a v-else-if="feed.state === 'Paused'" href="#" @click.prevent="() => activateFeed(feed.id)">Resume</a>
                            <span v-else>&nbsp;</span>
                        </td>
                        <td>
                            <a v-if="feed.state !== 'Deleted'" href="#" @click.prevent="() => runFeed(feed.id, false)">Run</a>
                            <span v-else>&nbsp;</span>
                        </td>
                        <td>
                            <a v-if="feed.state !== 'Deleted'" href="#" @click.prevent="() => runFeed(feed.id, true)">Run no zip</a>
                            <span v-else>&nbsp;</span>
                        </td>
                        <td><a href="#" @click.prevent="() => openLog(feed.id)">Logs</a></td>
                        <td><a :href="url(`admin/settings/feeds/${feed.id}/edit`)">Edit</a></td>
                        <td><a :href="feed.url" target="_blank">URL</a></td>
                        <td>
                            <a v-if="feed.state !== 'Deleted'" href="#" @click.prevent="() => deleteFeed(feed.id)">Delete</a>
                            <a v-else href="#" @click.prevent="() => undeleteFeed(feed.id)">Undelete</a>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td colspan="10" style="text-align: center;">No feeds found</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <el-dialog
            title="Feed Log"
            :visible.sync="logDialog.isVisible"
            width="70%">
            <div v-loading="logDialog.isLoading">
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th>Started at</th>
                                <th>Finished at</th>
                                <th>Status</th>
                                <th>Output</th>
                            </tr>
                            </thead>
                            <tbody v-if="logDialog.logs.length > 0">
                            <tr v-for="log in logDialog.logs">
                                <td>{{ log.started_at !== null ? moment(log.started_at).format('YYYY-MM-DD hh:mm:ss') : '' }}</td>
                                <td>{{ log.finished_at !== null ? moment(log.finished_at).format('YYYY-MM-DD hh:mm:ss') : '' }}</td>
                                <td>{{ log.status }}</td>
                                <td><textarea>{{ log.output }}</textarea></td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="4" style="text-align: center;">No log entries found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="logDialog.isVisible = false">Close</el-button>
            </span>
        </el-dialog>

        <parser-list :is-open.sync="openParsersList" @close="openParsersList = false"></parser-list>
    </div>
</template>

<script>
import parserList from './parser-list';

export default {
    components: { parserList },
    props: [
        'states',
        'agencies',
    ],
    data() {
        return {
            isLoading: false,
            stateFilter: '',
            agencyFilter: '',
            feeds: [],
            logDialog: {
                isVisible: false,
                isLoading: false,
                feedId: null,
                logs: [],
            },
            openParsersList: false,
        };
    },
    mounted() {
        this.refreshList();
    },
    methods: {
        refreshList() {
            this.isLoading = true;
            return axios.get(url(`admin/settings/feeds-get-list?state=${this.stateFilter}&agency=${this.agencyFilter}`))
                        .then(response => {
                            this.feeds = response.data.feeds;
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
        },
        runRequest(requestLink) {
            this.isLoading = true;
            return axios.get(url(requestLink))
                        .then(response => {
                            return this.refreshList();
                        });
        },
        activateFeed(feedId) {
            return this.runRequest(`admin/settings/feeds/${feedId}/activate`);
        },
        inactivateFeed(feedId) {
            return this.runRequest(`admin/settings/feeds/${feedId}/inactivate`);
        },
        runFeed(feedId, noZip) {
            return this.runRequest(`admin/settings/feeds/${feedId}/${noZip ? 'run-no-zip' : 'run'}`);
        },
        deleteFeed(feedId) {
            return this.runRequest(`admin/settings/feeds/${feedId}/delete`);
        },
        undeleteFeed(feedId) {
            return this.runRequest(`admin/settings/feeds/${feedId}/undelete`);
        },
        openLog(feedId) {
            this.logDialog.feedId = feedId;
            this.logDialog.isLoading = true;
            this.logDialog.isVisible = true;
            this.logDialog.logs = [];

            return axios.get(url(`admin/settings/feeds/${feedId}/history`))
                        .then(response => {
                            this.logDialog.logs = response.data;
                            this.logDialog.isLoading = false;
                        });
        },
    },
};
</script>

<style>
.failed-feed {
    font-weight: bold;
    color: red;
}
</style>
